import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  IOtpResponse,
  IStepUpOtpRequest,
  OtpChannel,
} from '../../../../services/strong-customer-authentication/model';

@Injectable()
export class AuthenticatedScaOptionsService {
  constructor(
    private readonly http: HttpClient,
    @Inject('ORIGIN_URL') private originUrl: string
  ) {}

  async requestResendOTP(
    verificationToken: string,
    channel: OtpChannel
  ): Promise<IOtpResponse> {
    return this.http
      .post<IOtpResponse>(
        this.originUrl + '/api/StepUp/ResendOtp',
        AuthenticatedScaOptionsService.createRequest(verificationToken, channel)
      )
      .toPromise();
  }

  async requestSendOTP(
    verificationToken: string,
    channel: OtpChannel
  ): Promise<IOtpResponse> {
    return this.http
      .post<IOtpResponse>(
        this.originUrl + '/api/StepUp/SendOtp',
        AuthenticatedScaOptionsService.createRequest(verificationToken, channel)
      )
      .toPromise();
  }

  private static createRequest(
    verificationToken: string,
    channel: OtpChannel
  ): IStepUpOtpRequest {
    return {
      verificationToken,
      channel,
    };
  }
}
